import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  // { field: "rail", label: "Zonal Railway" },
  { field: "pohtype", label: "POH Type" },
  { field: "pohsubtype", label: "POH Sub Type" },
  { field: "noofcoaches", label: "Coaches" },
  { field: "Mech_LabourCost", label: "Labour Cost(Mechanical)" },
  { field: "Mech_MaterialCost", label: "Material Cost(Mechanical)" },
  { field: "Elec_LabourCost", label: "Labour Cost(Electical)" },
  { field: "Elec_MaterialCost", label: "Material Cost(Electical)" },
  { field: "totalcost", label: "Total" },
];

export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
       stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              hover
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: "grey.50",
                },
              }}
            >
              {/* <TableCell align="right">{row.rail}</TableCell> */}

              <TableCell align="left" sx={{ paddingLeft: "100px" }}>
                {row.pohtype}
              </TableCell>

              <TableCell align="left"  sx={{ paddingLeft: "100px" }}> 
                {row.pohsubtype}
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.noofcoaches} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.Mech_LabourCost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.Mech_MaterialCost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.Elec_LabourCost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.Elec_MaterialCost} />  
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={row.totalcost} />
              </TableCell>
            </TableRow>
          ))}

          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={2} align="center">
                {shop} Total
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.noofcoaches} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.Mech_LabourCost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.Mech_MaterialCost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.Elec_LabourCost} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.Elec_MaterialCost} />   
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.totalcost} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}